import React from "react";

const gradientMap = {
  red: "bg-gradient-to-br from-red-50/80 via-red-100/60 to-red-200/40",
  none: "bg-transparent",
};

const PageSection = ({
  children,
  className = "",
  gradient = "red",
  container = true,
  id,
  overflowHidden = true,
}) => {
  return (
    <section id={id} className={`relative ${overflowHidden ? 'overflow-hidden' : ''} ${className}`}>
      <div className={`absolute inset-0 -z-10 ${gradientMap[gradient] || gradientMap.red}`}></div>
      <div className="absolute -top-40 -left-32 -z-10 w-[36rem] h-[36rem] rounded-full bg-gradient-to-tr from-red-200/40 to-designer-primary/20 blur-3xl"></div>
      <div className="absolute -bottom-40 -right-32 -z-10 w-[40rem] h-[40rem] rounded-full bg-gradient-to-tr from-designer-primary/20 to-red-300/30 blur-3xl"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 -z-10 w-[60rem] h-[60rem] rounded-full bg-gradient-to-tr from-red-100/10 to-designer-primary/5 blur-3xl"></div>
      <div className={container ? "w-full px-4 sm:px-6 lg:px-8" : ""}>{children}</div>
    </section>
  );
};

export default PageSection;


